import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { useBackButton } from '../../utils/useBackButton';
import { IconArrowLeft } from '../icon/IconArrowLeft';
import { Flex } from '../layout/Flex';
import { Toolbar } from '../surface/Toolbar';
import { Typography } from '../typography/Typography';
import { CatalogUI } from './types';

interface HeaderProps {
    catalog: CatalogUI;
}

interface ArrowContainerParams {
    enabled: boolean;
}

const ArrowContainer = styled(Flex)
    .withConfig({ displayName: 'ArrowContainer' })
    .attrs<ArrowContainerParams>((props) => ({
        color: 'var(--color-primary)',
        justifyContent: 'center',
        alignItems: 'center',
        height: 56,
        width: 54,
        left: 0,
        top: 0,
        transition: 'opacity 0.2s',
        opacity: props.enabled ? 1 : 0,
        cursor: 'pointer',
    }))`
    position: absolute;
`;

export const CatalogHeader: FC<HeaderProps> = ({ catalog }) => {
    const onNavigateBack = useBackButton(catalog.business?.url);

    return (
        <Toolbar position="sticky" width="100%">
            <ArrowContainer enabled={true}>
                <IconArrowLeft
                    color="var(--color-primary)"
                    size={24}
                    onClick={() => onNavigateBack()}
                />
            </ArrowContainer>
            <Flex
                direction="row"
                width="100%"
                alignItems="center"
                justifyContent="center"
                p={1}
                height={56}
            >
                <Flex width="100%" alignItems="center" justifyContent="center">
                    <Typography variant="body" weight="bold">
                        {catalog.title}
                    </Typography>
                    {catalog.business?.url ? (
                        <Typography as={Link} to={catalog.business?.url} variant="caption">
                            {catalog.business?.displayName}
                        </Typography>
                    ) : null}
                </Flex>
            </Flex>
        </Toolbar>
    );
};
